import React, { useEffect, useRef, useState } from "react";
import "./styleAddTrendingPlatform.css";
import { setIsAddTrendingCard, setTrendingPlatformList } from "../../features/platforms/platformsSlice";
import { useDispatch, useSelector } from "react-redux";
import { getPlatformsByCategory, postTrendingPlatform, updateTrendingPlatform } from "../../services/platformServices";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import _ from "lodash";



function INCSUBAddTrendingPlatform(trenPlatform) {
    const dispatch = useDispatch();
    const categoryList = useSelector((state) => state.platforms.categoryList); // Redux state for category list
    const [platformsList, setPlatformsList] = useState(null);
    const navigate = useNavigate();
    const TrendingPlatformList = useSelector((state) => state.platforms.trendingPlatfromList)
    // State to store new platform details
    const [newTrendPlatform, setNewTrendPlatform] = useState(
        {
            trendingPlatformId: "",
            platformId: "",
            platformName: "",
            trendingPlatformImage: "",
            trendingImageFile: null,
            isVisible: true,
        }
    )
    useEffect(() => {
        fetchPlatformByCategory('');
        if (trenPlatform && trenPlatform.newPlatform) {
            setNewTrendPlatform(trenPlatform.newPlatform);
        }
    }, [trenPlatform.newPlatform])

    // State variables for validation and loading status
    const [isEmptyField, setIsEmptyField] = useState(false);
    const [loader, setLoader] = useState(false);

    const fetchPlatformByCategory = async (categoryId) => {
        try {
            const platformsList = await getPlatformsByCategory(categoryId);
            if (platformsList.status === 200) {
                setPlatformsList(platformsList.data.data.platformNameIdDtoList);

            } else if (platformsList.status === 301) {
                toast.error("Network Error");
            } else if (platformsList.status === 500) {
                toast.error("Internal server error");
            }
        } catch (err) {
            toast.error('Something went wrong');
        }
    }

    const [selectedCategory, setSelectedCategory] = useState({
        platformCategory: "",
        encryptedCategoryId: ""
    })
    const [isDisable, setIsDisable] = useState(false);
    /**
 * Handles category selection and updates the platform state.
 * @param {Event} e - The event triggered by category selection.
 */
    const handleCategory = async (e) => {
        setIsDisable(true)
        const category = await categoryList.filter((category) => category.categoryName === e.target.value);
        if (category.length > 0) {
            setSelectedCategory({
                ...selectedCategory,
                platformCategory: category[0].categoryName,
                encryptedCategoryId: category[0].categoryId
            });
            fetchPlatformByCategory(category[0].categoryId)
        } else {
            toast.warning("Category Not Found");
        }
        setIsDisable(false)
    }

    const handlePlatform = async (e) => {
        const platform = await platformsList.filter((platform) => platform.platformName === e.target.value);
        if (platform.length > 0) {
            setNewTrendPlatform((prev) => ({
                ...newTrendPlatform,
                platformName: platform[0].platformName,
                platformId: platform[0].platformId
            }));
        } else {
            toast.warning("platform not found");
        }
        setIsDisable(false)
    }

    /**
     * Handles file selection and reads the image file as a data URL and blob.
     * @param {Event} e - The file input change event.
     */

    const [imageError, setImageError] = useState();

    function onSelectFile(e) {
        if (e.target.files && e.target.files.length > 0) {
            const file = e.target.files[0];
            const reader = new FileReader();

            reader.onload = function (event) {
                const img = new Image();
                img.onload = function () {
                    const aspectRatio = img.width / img.height;
                    const targetRatio = 3 / 2;

                    // Allow for a small tolerance due to potential rounding
                    const tolerance = 0.01;
                    if (Math.abs(aspectRatio - targetRatio) > tolerance) {

                        setImageError(true);

                    } else {
                        setImageError(false);
                    }


                    const blob = new Blob([file], { type: file.type });
                    setNewTrendPlatform((prev) => ({
                        ...prev,
                        trendingImageFile: blob,
                        trendingPlatformImage: reader.result?.toString() || '',
                    }));
                };
                img.src = event.target.result;
            };

            reader.readAsDataURL(file);
        }
    }



    const addPlatform = async () => {
        setLoader(true);
        const isInvalid = [
            newTrendPlatform.platformId,
            newTrendPlatform.trendingImageFile,
        ].some(field => field === '' || field === null || field === undefined);
        if (isInvalid) {
            setIsEmptyField(true);
            setLoader(false)
            return;
        }
        if (imageError) {
            setIsEmptyField(true);
            setLoader(false)
            return
        }
        try {
            const data = await postTrendingPlatform(newTrendPlatform);

            if (data.status === 201) {
                toast.done("Platform Added successfuly")
                const updatedPlatformList = [...TrendingPlatformList,
                {
                    trendingPlatformId: data.data.data.trendingPlatformId,
                    platformId: newTrendPlatform.platformId,
                    platformName: newTrendPlatform.platformName,
                    trendingPlatformImage: newTrendPlatform.trendingPlatformImage,
                    imageFile: newTrendPlatform.trendingImageFile,
                    isVisible: newTrendPlatform.isVisible
                }
                ];
                dispatch(setTrendingPlatformList(updatedPlatformList));

            }
            if (data.status === 401) {
                window.localStorage.setItem('token', null)
                navigate('/login')
                return
            }
            if ([409, 400].includes(data.status)) {
                toast.error(data.data.message);
            }
            setLoader(false)
            dispatch(setIsAddTrendingCard(false))
        } catch (err) {
            console.error("Error adding platform:", err);
            setLoader(false)
        }
    };


    const findUpdatedFields = (original, updated) => {
        let updatedData = {};
        Object.keys(original).forEach(key => {
            if (original[key] !== updated[key]) {
                updatedData[key] = updated[key];
            }
        });

        // Add platformPlanId only once if updates exist
        if (Object.keys(updatedData).length > 0) {
            updatedData.platformPlanId = original.platformPlanId;
        }

        return Object.keys(updatedData).length > 0 ? updatedData : false;
    };

    const changePlatform = async () => {
        const arePlatformsEqual = _.isEqual(trenPlatform.platform, newTrendPlatform);
        if (arePlatformsEqual) {
            toast.warning("No change in previous data");
            return
        }

        setLoader(true);
        if (imageError) {
            setIsEmptyField(true);
            setLoader(false)
            return
        }
        try {
            const updatedData = findUpdatedFields(trenPlatform.newPlatform, newTrendPlatform);
            console.log(trenPlatform.newPlatform)
            console.log(newTrendPlatform)
            console.log(updatedData)
            if (!updatedData) {
                toast.warning('No change in previous message')
                return
            }

            const data = await updateTrendingPlatform(newTrendPlatform);

            if (data.status === 200) {
                const updatedTrendingPlatform = {
                    trendingPlatformId: newTrendPlatform.trendingPlatformId,
                    platformId: newTrendPlatform.platformId,
                    platformName: newTrendPlatform.platformName,
                    trendingPlatformImage: newTrendPlatform.trendingPlatformImage,
                    trendingImageFile: newTrendPlatform.trendingImageFile,
                    isVisible: newTrendPlatform.isVisible,
                }
                const updatedList = TrendingPlatformList.map(trendingPlatform =>
                    trendingPlatform.trendingPlatformId === updatedTrendingPlatform.trendingPlatformId
                        ? { ...trendingPlatform, ...updatedTrendingPlatform } // Update matched category
                        : trendingPlatform
                );
                dispatch(setTrendingPlatformList(updatedList))
            } else if (data.status === 301) {
                toast.error("Network Error");
            } else if (data.status === 500) {
                toast.error("Internal server error");
            } else if (data.status === 401) {
                window.localStorage.setItem('token', null)
                navigate('/login')
            } else if ([409, 400].includes(data.status)) {
                toast.error(data.data.message);
            }

            setLoader(false);
            dispatch(setIsAddTrendingCard(false));
        } catch (err) {
            console.error("Error adding platform:", err);
            setLoader(false);
        }
    };

    return (
        <div className="INCSUBAddTrendingPlatform">
            <div className="INCSUBAddTrendingPlatform_container">
                <div className="INCSUBAddTrendingPlatform_feilds_container">
                    <svg className="cancel_btn" onClick={() => dispatch(setIsAddTrendingCard(false))} width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.46416 1.47683C1.77145 1.16963 2.18818 0.997049 2.6227 0.997049C3.05721 0.997049 3.47394 1.16963 3.78124 1.47683L9.99672 7.69231L16.2122 1.47683C16.3634 1.32032 16.5442 1.19548 16.7441 1.1096C16.944 1.02372 17.1591 0.978515 17.3766 0.976624C17.5942 0.974734 17.81 1.01619 18.0114 1.09859C18.2128 1.18098 18.3957 1.30266 18.5496 1.45652C18.7035 1.61038 18.8251 1.79334 18.9075 1.99473C18.9899 2.19611 19.0314 2.41189 19.0295 2.62947C19.0276 2.84706 18.9824 3.06208 18.8965 3.26201C18.8106 3.46193 18.6858 3.64275 18.5293 3.79391L12.3138 10.0094L18.5293 16.2249C18.8278 16.5339 18.9929 16.9479 18.9892 17.3775C18.9855 17.8072 18.8131 18.2182 18.5093 18.522C18.2055 18.8258 17.7945 18.9982 17.3648 19.0019C16.9352 19.0056 16.5213 18.8405 16.2122 18.542L9.99672 12.3265L3.78124 18.542C3.47218 18.8405 3.05825 19.0056 2.62859 19.0019C2.19894 18.9982 1.78794 18.8258 1.48412 18.522C1.18029 18.2182 1.00796 17.8072 1.00422 17.3775C1.00049 16.9479 1.16566 16.5339 1.46416 16.2249L7.67964 10.0094L1.46416 3.79391C1.15695 3.48661 0.984375 3.06989 0.984375 2.63537C0.984375 2.20085 1.15695 1.78413 1.46416 1.47683Z" fill="black" />
                    </svg>

                    <div className="INCSUBAddTrendingPlatform_heading">Add Trending Card</div>
                    <div className="INCSUBAddTrendingPlatform_form_container">
                        <form>
                            <div className="INCSUBAddTrendingPlatform_form_halffeild_container">
                                <div className="INCSUBAddTrendingPlatform_form_fullfeild_container half">
                                    <label>Categories</label>
                                    <select onChange={handleCategory} value={selectedCategory.platformCategory} style={{ color: selectedCategory.platformCategory === '' ? '#A6A6A6' : null, border: selectedCategory.platformCategory === '' && isEmptyField ? '1px solid red' : null }} placeholder="Select a category" >
                                        <option value={''} style={{ color: '#A6A6A6' }} disabled selected>Select a Category</option>
                                        {
                                            categoryList && categoryList.map((category, index) => <option value={category.categoryName}>{category.categoryName}</option>)
                                        }
                                    </select>
                                </div>
                                <div className="INCSUBAddTrendingPlatform_form_fullfeild_container half">
                                    <label>Platforms</label>
                                    <select onChange={handlePlatform} value={newTrendPlatform.platformName} style={{ color: newTrendPlatform.platformName === '' ? '#A6A6A6' : null, border: newTrendPlatform.platformName === '' && isEmptyField ? '1px solid red' : null }} placeholder="Select a category" disabled={!platformsList || platformsList.length < 0 || isDisable ? true : false}>
                                        <option value={''} style={{ color: '#A6A6A6' }} disabled selected>Select a Platform</option>
                                        {
                                            platformsList && platformsList.map((platform, index) => <option value={platform.platformName}>{platform.platformName}</option>)
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="INCSUBAddTrendingPlatform_form_halffeild_container">
                                <div className="INCSUBAddTrendingPlatform_image_container" >
                                    <label>Image</label>
                                    <div className="INCSUBAddTrendingPlatform_image" style={{  border: newTrendPlatform.trendingPlatformImage === '' && isEmptyField ? '1px solid red' : null }}>
                                        <input type="file" accept="image/*" onChange={onSelectFile} />
                                        <svg
                                            width="37"
                                            height="37"
                                            viewBox="0 0 37 37"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M18.5 7.71094V29.2943"
                                                stroke="#606060"
                                                strokeWidth="3.08333"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M7.7085 18.5H29.2918"
                                                stroke="#606060"
                                                strokeWidth="3.08333"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                        {
                                            newTrendPlatform.trendingPlatformImage && <img className='INCSUBDisplay_img' src={newTrendPlatform.trendingPlatformImage} alt='/' />
                                        }
                                    </div>

                                    <div className="INCSUBAddTrendingPlatform_image_ratio" style={{ color: imageError ? "red" : null }}>
                                        JPG / Size. 300x200
                                        {imageError ? ' Wrong size' : null}

                                    </div>
                                </div>
                            </div>

                            <div className="INCSUBAddTrendingPlatform_form_fullfeild_container">
                                <div className='INCSUBusrupdate_btn submit' onClick={() => !loader ? (!trenPlatform.newPlatform ? addPlatform() : changePlatform()) : null}>{!loader ? (!trenPlatform.newPlatform ? "Add" : "Update") : <div className="btnLoader" />}</div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default INCSUBAddTrendingPlatform;
